var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "../../views/base.component";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "../../translate";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { EventsService } from "../../lib/EventsService";
import { ChartParams } from "../../views/chart/chart.component";
import merge from 'lodash-es/merge';
import { SitesService } from "../sites.service";
import { FormControl, FormGroup } from "@angular/forms";
import { RouteProvider } from "../../provider/route.provider";
import { debounceTime, switchMap } from "rxjs/operators";
import { of } from "rxjs";
var SiteActionComponent = /** @class */ (function (_super) {
    __extends(SiteActionComponent, _super);
    function SiteActionComponent(activatedRoute, translate, filter, eventsService, routeProvider, siteService) {
        var _this = _super.call(this, eventsService, siteService, activatedRoute, filter, translate) || this;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.routeProvider = routeProvider;
        _this.siteService = siteService;
        _this.addFilterParams = {
            period: 'month',
            relativeInverval: {
                type: 'day',
                value: 1,
                border: 300,
            }
        };
        _this.conversionChart = new ChartParams({
            axis: {
                y: {
                    show: true,
                    label: {
                        text: '%',
                        position: 'outer-middle'
                    }
                }
            },
        });
        _this.actionChart = new ChartParams({
            axis: {
                x: {
                    label: {
                        text: 'Дата регистрации пользователя',
                        position: 'outer-middle'
                    }
                },
                y: {
                    show: true,
                    label: {
                        text: 'Среднее кол-во действий для сайта',
                        position: 'outer-middle'
                    }
                }
            },
        });
        _this.form = new FormGroup({
            value: new FormControl(1),
            type: new FormControl('day'),
            border: new FormControl(300),
        });
        _this.conversionChart.setOptions({
            title: 'Конверсии',
            names: {
                pureConversion: _this.translate.__A('site_action.pureConversion'),
                metrickConversion: _this.translate.__A('site_action.metrickConversion'),
            },
        });
        _this.actionChart.setOptions({
            names: {
                avgActionPerPaidSite: _this.translate.__A('site_action.avgActionPerPaidSite'),
                avgActionPerFreeSite: _this.translate.__A('site_action.avgActionPerFreeSite'),
            },
        });
        return _this;
    }
    SiteActionComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var me = this;
        me.form.valueChanges
            .pipe(debounceTime(1000), switchMap(function (_a) {
            var type = _a.type, value = _a.value, border = _a.border;
            return of(me.routeProvider.navigate({
                relativeInverval: {
                    type: type,
                    value: value,
                    border: border,
                },
            }));
        }))
            .subscribe(function () {
            console.log('form changed!');
        });
    };
    SiteActionComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConversionCharts()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getCharts()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SiteActionComponent.prototype.getConversionCharts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        fp = me.filter.filterParams;
                        me.conversionChart.showLoader();
                        return [4 /*yield*/, me.siteService.siteAction.chart(merge({}, me.addFilterParams, fp), 'conversion/charts').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.conversionChart.data = charts;
                        me.conversionChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    SiteActionComponent.prototype.getCharts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, title, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        fp = me.filter.filterParams;
                        title = "\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u043A\u043E\u043B-\u0432\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0434\u043B\u044F \u0441\u0430\u0439\u0442\u0430 \u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434 (" + fp.relativeInverval.value + " " + fp.relativeInverval.type + ")";
                        me.actionChart.setOptions({ title: title });
                        me.actionChart.showLoader();
                        return [4 /*yield*/, me.siteService.siteAction.chart(merge({}, me.addFilterParams, fp)).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.actionChart.data = charts;
                        me.actionChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    return SiteActionComponent;
}(BaseComponent));
export { SiteActionComponent };
